import React from "react";
import { useDispatch } from "react-redux";
import { setAlterationRequestFilter } from "../../store/orderSlice";

const Widget = ({ mainClass, textColorClass, isActive, value, label, sublabel, onClick }) => {
  return (
    <div style={{ flex: "0 0 calc(20% - 10px)", maxWidth: "calc(20% - 10px)", margin: "5px" }}>
      <div className={`widget-rounded-circle card-box summary-card-box cursor-pointer ${mainClass} ${isActive ? "active" : ""}`} onClick={onClick}>
        <h6 className="text-truncate card-box-title">{label}</h6>
        <div className="row">
          <div className="col-auto">
            <h5 className={`card-box-subtitle`}>{sublabel}</h5>
          </div>
          <div className="col">
            <h5 className={`card-box-value text-right ${textColorClass}`}>{value}</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

const StatusSummary = ({ orderState ,dataLoading}) => {
  const dispatch = useDispatch();

  const statusSummary = orderState.alterationStatusSummary;
  const customStatus = orderState.alterationFilters.customStatus ? orderState.alterationFilters.customStatus : null;

  const onClickStatusFilter = (customStatusId) => {
    if(dataLoading) return;
    
    dispatch(
      setAlterationRequestFilter({
        ...orderState.alterationFilters,
        customStatus: orderState.alterationFilters.customStatus === customStatusId ? null : customStatusId,
        status: null,
        currentPage: 1,
      })
    );
  };

  console.log("statusSummary", statusSummary);

  const widgetsData = [
    {
      value: statusSummary && statusSummary.alteration_request_in_transit ? statusSummary.alteration_request_in_transit : 0,
      label: "Alteration Request in Transit",
      sublabel: "[No action needed]",
      mainClass: "card-box-info",
      isActive: customStatus == 1,
      onClick: () => onClickStatusFilter(1),
    },
    {
      value: statusSummary && statusSummary.alteration_request_delivered ? statusSummary.alteration_request_delivered : 0,
      label: "Alteration Request Delivered, Not Processed",
      sublabel: "[Action Needed]",
      mainClass: "card-box-danger",
      isActive: customStatus == 2,
      onClick: () => onClickStatusFilter(2),
    },
    {
      value: statusSummary && statusSummary.alteration_request_completed ? statusSummary.alteration_request_completed : 0,
      label: "Alteration Request Completed",
      sublabel: "[No Action Needed]",
      mainClass: "card-box-warning",
      isActive: customStatus == 3,
      onClick: () => onClickStatusFilter(3),
    },
    {
      value: statusSummary && statusSummary.alteration_decline_in_transit ? statusSummary.alteration_decline_in_transit : 0,
      label: "Alteration Decline In Transit",
      sublabel: "[No Action Needed]",
      mainClass: "card-box-secondary",
      isActive: customStatus == 4,
      onClick: () => onClickStatusFilter(4),
    },
    {
      value: statusSummary && statusSummary.alteration_decline_delivered ? statusSummary.alteration_decline_delivered : 0,
      label: "Alteration Decline Delivered",
      sublabel: "[No Action Needed]",
      mainClass: "card-box-primary",
      isActive: customStatus == 5,
      onClick: () => onClickStatusFilter(5),
    },
    {
      value: statusSummary && statusSummary.alteration_completed_in_transit ? statusSummary.alteration_completed_in_transit : 0,
      label: "Alteration Completed In Transit",
      sublabel: "[No Action Needed]",
      mainClass: "card-box-brown",
      isActive: customStatus == 6,
      onClick: () => onClickStatusFilter(6),
    },
    {
      value: statusSummary && statusSummary.alteration_completed_delivered ? statusSummary.alteration_completed_delivered : 0,
      label: "Alteration Completed Delivered",
      sublabel: "[No Action Needed]",
      mainClass: "card-box-teal",
      isActive: customStatus == 7,
      onClick: () => onClickStatusFilter(7),
    },
    {
      value: statusSummary && statusSummary.alteration_request_stuck_in_transit ? statusSummary.alteration_request_stuck_in_transit : 0,
      label: "Alteration Request Stuck in Transit",
      sublabel: "[Action Needed]",
      mainClass: "card-box-orange",
      isActive: customStatus == 8,
      onClick: () => onClickStatusFilter(8),
    },
    {
      value: statusSummary && statusSummary.alteration_decline_stuck_in_transit ? statusSummary.alteration_decline_stuck_in_transit : 0,
      label: "Alteration Decline Stuck in Transit",
      sublabel: "[Action Needed]",
      mainClass: "card-box-purple",
      isActive: customStatus == 9,
      onClick: () => onClickStatusFilter(9),
    },
    {
      value: statusSummary && statusSummary.alteration_completed_stuck_in_transit ? statusSummary.alteration_completed_stuck_in_transit : 0,
      label: "Alteration Completed Stuck in Transit",
      sublabel: "[Action Needed]",
      mainClass: "card-box-success",
      isActive: customStatus == 10,
      onClick: () => onClickStatusFilter(10),
    },
  ];

  return (
    <>
      <div className="row">
        {widgetsData.map((widget, index) => (
          <Widget
            key={"s" + index}
            mainClass={widget.mainClass}
            // textColorClass={widget.textColorClass}
            value={widget.value}
            label={widget.label}
            sublabel={widget.sublabel}
            onClick={widget.onClick}
            isActive={widget.isActive ?? false}
          />
        ))}
      </div>
    </>
  );
};

export default StatusSummary;
